import { useEffect } from 'react';
import { useTour } from './TourContext';
import { CHAT_INTROS, decideIntro, buildIntroBody } from './chatIntros';

// INTRO-2 — drop beside useAutoTour in each eligible screen. On mount it decides,
// using the shared tour-progress state, whether to fire the first-use chat intro:
//   • only on screens with intro content (the approved 10)
//   • for auto-tour screens, only once that tour is terminal (never co-fires)
//   • never while a guide is open
//   • once per screen, and at most THREE per user ever (derived from chat:* records)
// When it fires it reuses the App chat bridge via the aidey:chat-intro event, which
// App turns into setProactiveMessage({ kind:'intro', body }) + setShowAideyChat(true).
export default function useChatIntro(tourId, { delayMs = 1200 } = {}) {
  const { hasSeenTour, loaded, progress, isGuideOpen, recordChatIntro } = useTour();

  const content = CHAT_INTROS[tourId];
  const gateOnTour = content ? content.gateOnTour : true;
  const seen = tourId ? hasSeenTour(tourId) : false;

  useEffect(() => {
    if (!loaded || !content) return;

    const { fire, isThird } = decideIntro({
      tourId, gateOnTour, hasSeenTour: seen, guideOpen: isGuideOpen, progress,
    });
    if (!fire) return;

    const timer = setTimeout(() => {
      // Re-decide at fire time so a guide opened during the delay cancels the intro.
      const again = decideIntro({ tourId, gateOnTour, hasSeenTour: seen, guideOpen: isGuideOpen, progress });
      if (!again.fire) return;
      const body = buildIntroBody(tourId, again.isThird);
      window.dispatchEvent(new CustomEvent('aidey:chat-intro', { detail: { tourId, body } }));
      recordChatIntro(tourId);
    }, delayMs);

    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loaded, tourId, seen, isGuideOpen, progress]);
}
